import { Box, Card, CardContent, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { SkeletonLoader, OfferCard } from '../../global/Common';
import { getOfferStatus } from '../MesOffres/utils';
import { Offer } from '../MesOffres/types';

interface OffersCarouselProps {
  offers: Offer[];
  loading: boolean;
  primaryColor: string;
  onOfferClick: (offer: Offer) => void;
  t: (key: string) => string;
}

export const OffersCarousel = ({ offers, loading, primaryColor, onOfferClick, t }: OffersCarouselProps) => {
  const availableOffers = offers.filter(offer => getOfferStatus(offer) === 'available');

  return (
    <Box>
      <Box sx={{ mb: 1.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1, fontSize: '1.25rem' }}>
        <i className="bx bx-gift" style={{ fontSize: 24, color: primaryColor }} />
        {t('pages.offers.title')}
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 2 }}>
          {[1, 2, 3].map((item) => (
            <Card key={item}>
              <CardContent>
                <SkeletonLoader count={4} />
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : availableOffers.length > 0 ? (
        <Swiper
          modules={[Pagination]}
          spaceBetween={16}
          slidesPerView={1}
          pagination={{ clickable: true, dynamicBullets: true }}
          loop={availableOffers.length > 1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{ paddingBottom: '40px' }}
        >
          {availableOffers.map((offer, index) => (
            <SwiperSlide key={index}>
              <OfferCard 
                offer={offer}
                onClick={() => onOfferClick(offer)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <i className="bx bx-gift" style={{ fontSize: 48, color: '#adb5bd' }} />
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
              {t('pages.offers.noOffers')}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};
